import { useTranslator } from "@brickme/frontend-common/src/i18n/translation.tsx";
import { useBranding } from "@brickme/d2c-branding/src/browser/context.tsx";
import "./loading-animation.scss";

type LoadingAnimationProps = {
	readonly size?: number;
	readonly children?: string;
};

function LoadingAnimation({ size = 150, children }: LoadingAnimationProps) {
	const t = useTranslator();
	const { loadingSquareAnimation } = useBranding();
	return (
		<div className="loading-animation">
			<img
				src={loadingSquareAnimation}
				width={size}
				height={size}
				alt={t("Loading")}
				decoding="async"
				loading="lazy"
			/>
			{children}
		</div>
	);
}

export default LoadingAnimation;
